import { useNumericParams } from '@domain-group/react-hooks'

import PageContent from './components/PageContent'

const SalesforceDetails = () => {
  const { providerId } = useNumericParams()

  return <PageContent providerId={providerId} />
}

export default SalesforceDetails
